// extracted by mini-css-extract-plugin
export default {"card":"ImgRank_card__R1TQK","card_header":"ImgRank_card_header__mRVwQ","card_header_title":"ImgRank_card_header_title__IBgn1","content_column3":"ImgRank_content_column3__T0obR"};